import { useCssVars as I, createElementBlock as n, openBlock as l, createElementVNode as s, createCommentVNode as u, renderSlot as c, toDisplayString as m, normalizeStyle as Ce, computed as z, normalizeClass as y, createVNode as C, unref as _, createBlock as w, resolveDynamicComponent as V, withCtx as p, ref as L, watch as O, withModifiers as de, nextTick as fe, withDirectives as ae, vShow as le, Fragment as B, renderList as D, useSlots as R, onMounted as $e, createTextVNode as j, createSlots as qe } from "vue";
/* empty css                      */
import { _ as $, v as J, d as Pe, c as we, b as Ie } from "./ds-atom-stars-DChLrLRI.js";
import { f as xe, a as Le, b as Te, c as Ee, d as Ae, e as Me, g as Be, h as He, i as ze, j as De, k as Re, l as Ne, m as Ue, n as Ve, o as Ke, p as Oe, q as Fe, r as Ge, s as Ye, t as Xe, u as We, v as je, w as Je, x as Qe, y as Ze, z as et, A as tt, B as at, C as lt, D as it, E as nt, F as rt, G as st, H as ot, I as ut, J as ct, K as dt, L as ft, M as gt, N as mt, O as ht, P as bt, Q as yt, R as vt, S as kt, T as _t, U as St, V as pt, W as Ct, X as $t, Y as qt, Z as Pt, _ as wt, $ as It, a0 as xt, a1 as Lt, a2 as Tt, a3 as Et, a4 as At, a5 as Mt, a6 as Bt, a7 as ge, a8 as me, a9 as Ht, aa as zt, ab as Dt, ac as Rt, ad as Nt, ae as Ut, af as Vt, ag as Kt, ah as Ot, ai as Ft, aj as Gt, ak as Yt, al as Xt, am as Wt, an as jt, ao as Jt, ap as Qt, aq as Zt, ar as ea, as as Q, at as ie, au as ne, av as re, aw as ta, ax as aa, ay as la, az as ia, aA as na } from "./yelp-DbcUpF0x.js";
import { storeToRefs as ra } from "pinia";
const sa = { class: "bar-process-container" }, oa = { class: "bar-process" }, ua = {
  key: 0,
  class: "bar-process__text"
}, ca = {
  key: 0,
  class: "bar-process__percentage u-regular u-bold"
}, da = {
  key: 0,
  class: "bar-process__status u-tiny-text"
}, fa = { class: "bar-process__bar" }, ga = {
  __name: "ds-atom-bar-process",
  props: {
    showPercentage: {
      type: Boolean,
      default: !0
    },
    percentage: {
      type: String,
      required: !0,
      default: ""
    },
    status: {
      type: String,
      required: !1,
      default: ""
    },
    statusColor: {
      type: String,
      required: !1,
      default: ""
    },
    percentageColor: {
      type: String,
      required: !1,
      default: ""
    },
    barBackground: {
      type: String,
      required: !1,
      default: ""
    },
    filledBarBackground: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((a) => ({
      b1458690: t.status,
      d141223a: t.percentageColor,
      "8d3c8bca": t.barBackground,
      "563a6f4e": t.filledBarBackground
    }));
    const t = e;
    return (a, i) => (l(), n("div", sa, [
      s("div", oa, [
        e.showPercentage && e.percentage || e.status ? (l(), n("div", ua, [
          c(a.$slots, "percentage", { classes: ["bar-process__percentage"] }, () => [
            e.showPercentage && e.percentage ? (l(), n("div", ca, m(e.percentage) + "% ", 1)) : u("", !0)
          ], !0),
          c(a.$slots, "status", { classes: ["bar-process__status"] }, () => [
            e.status ? (l(), n("p", da, m(e.status), 1)) : u("", !0)
          ], !0)
        ])) : u("", !0),
        s("div", fa, [
          s("div", {
            class: "bar-process__bar-filled",
            style: Ce({ width: `${e.percentage}%` })
          }, null, 4)
        ])
      ])
    ]));
  }
}, Ci = /* @__PURE__ */ $(ga, [["__scopeId", "data-v-079c3158"]]), ma = {
  faThumbsUp: Zt,
  faThumbsDown: Qt,
  faEnvelope: Jt,
  faCheck: jt,
  faPhone: Wt,
  faStar: Xt,
  faHeart: Yt,
  faArrowRight: Gt,
  faArrowLeft: Ft,
  faArrowDown: Ot,
  faArrowUp: Kt,
  faCircleXmark: Vt,
  faXmark: Ut,
  faCircleInfo: Nt,
  faShare: Rt,
  faCircleExclamation: Dt,
  faLink: zt,
  faInfo: Ht,
  faChevronRight: me,
  faChevronLeft: ge,
  faChevronDown: Bt,
  faChevronUp: Mt,
  faSquare: At,
  faExclamation: Et,
  faCircleCheck: Tt,
  faCircleChevronRight: Lt,
  faCircleChevronLeft: xt,
  faCircleChevronDown: It,
  faCircleChevronUp: wt,
  faCircleArrowRight: Pt,
  faCircleArrowLeft: qt,
  faCircleArrowDown: $t,
  faCircleArrowUp: Ct,
  faClock: pt,
  faFacebook: St,
  faLinkedin: _t,
  faYoutube: kt,
  faGoogle: vt,
  faInstagram: yt,
  faTiktok: bt,
  faWordpress: ht,
  faPinterest: mt,
  faXTwitter: gt,
  faTwitter: ft,
  faPinterestP: dt,
  faLinkedinIn: ct,
  faFacebookF: ut,
  faThumbsUpSolid: ot,
  faThumbsDownSolid: st,
  faEnvelopeSolid: rt,
  faCheckSolid: nt,
  faPhoneSolid: it,
  faStarSolid: lt,
  faHeartSolid: at,
  faArrowRightSolid: tt,
  faArrowLeftSolid: et,
  faArrowDownSolid: Ze,
  faArrowUpSolid: Qe,
  faCircleXmarkSolid: Je,
  faXmarkSolid: je,
  faCircleInfoSolid: We,
  faShareSolid: Xe,
  faCircleExclamationSolid: Ye,
  faLinkSolid: Ge,
  faInfoSolid: Fe,
  faChevronRightSolid: Oe,
  faChevronLeftSolid: Ke,
  faChevronDownSolid: Ve,
  faChevronUpSolid: Ue,
  faSquareSolid: Ne,
  faExclamationSolid: Re,
  faCircleCheckSolid: De,
  faCircleChevronRightSolid: ze,
  faCircleChevronLeftSolid: He,
  faCircleChevronDownSolid: Be,
  faCircleChevronUpSolid: Me,
  faCircleArrowRightSolid: Ae,
  faCircleArrowLeftSolid: Ee,
  faCircleArrowDownSolid: Te,
  faCircleArrowUpSolid: Le,
  faClockSolid: xe
}, ha = {
  __name: "ds-atom-icon",
  props: {
    icon: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !1,
      default: "solid"
    },
    size: {
      type: [String, Number],
      required: !1,
      default: "auto"
    },
    color: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((i) => ({
      "81a5c846": t.color
    })), ea.add(ma);
    const t = e, a = z(() => t.type === "solid" ? "fas" : t.type === "regular" ? "far" : "fab");
    return (i, r) => (l(), n("div", {
      class: y(["icon", `icon--${e.size}`])
    }, [
      C(_(Q), {
        icon: [a.value, t.icon]
      }, null, 8, ["icon"])
    ], 2));
  }
}, A = /* @__PURE__ */ $(ha, [["__scopeId", "data-v-f7365487"]]), ba = { class: "mp-button-container" }, ya = { class: "mp-button__inner" }, va = { class: "mp-button__icon" }, ka = {
  key: 0,
  class: "mp-button__icon"
}, _a = ["innerHTML"], Sa = { class: "mp-button-wrapper" }, pa = {
  key: 0,
  class: "mp-button__icon"
}, Ca = ["innerHTML"], $a = {
  key: 2,
  class: "mp-button__icon"
}, qa = { class: "mp-button__underline-text" }, Pa = {
  __name: "ds-atom-button",
  props: {
    buttonType: {
      type: String,
      required: !1,
      default: "main"
    },
    component: {
      type: String,
      required: !1,
      default: "button"
    },
    url: {
      type: String,
      required: !1,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    size: {
      type: String,
      required: !1,
      default: "large"
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: !1
    },
    fitWidthMobile: {
      type: Boolean,
      required: !1,
      default: !1
    },
    text: {
      type: String,
      required: !1,
      default: null
    },
    textAlignment: {
      type: String,
      required: !1,
      default: "center"
    },
    iconLeft: {
      type: String,
      required: !1,
      default: ""
    },
    iconRight: {
      type: String,
      required: !1,
      default: ""
    },
    enableUnderline: {
      type: Boolean,
      required: !1,
      default: !1
    },
    underlineText: {
      type: String,
      required: !1,
      default: ""
    },
    underlineIcon: {
      type: String,
      required: !1,
      default: ""
    },
    underlineAlignment: {
      type: String,
      required: !1,
      default: "left"
    },
    enableBackButton: {
      type: Boolean,
      required: !1,
      default: !1
    },
    backButtonComponent: {
      type: String,
      required: !1,
      default: "button"
    },
    backButtonUrl: {
      type: String,
      required: !1,
      default: ""
    },
    backButtonDisabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    backIcon: {
      type: String,
      required: !1,
      default: ""
    },
    backText: {
      type: String,
      required: !1,
      default: "Back"
    }
  },
  emits: ["click", "back"],
  setup(e, { emit: t }) {
    I((v) => ({
      "84efebac": a.background || null,
      "497274e0": a.backgroundHover || null,
      "4d9bede0": a.backgroundActive || null,
      "1d5d7898": a.stroke || null,
      "3b01a196": a.strokeHover || null,
      "1988731a": a.strokeActive || null,
      "188172b0": a.textColor || null,
      "6684d5e0": a.textHoverColor || null,
      "7f006ac2": a.textActiveColor || null,
      "45658adc": a.iconColor || null,
      "15c45d48": a.iconHoverColor || null,
      "62a7b7f6": a.iconActiveColor || null,
      "71ba652e": a.backColor || null,
      "2ca2cb6c": a.backHoverColor || null,
      "00300cc8": a.backActiveColor || null,
      29003173: a.underlineColor || null,
      "1f5944fa": a.underlineIconColor || null
    }));
    const a = e, i = t, r = (v) => {
      a.disabled || i("click", v);
    }, d = (v) => {
      a.backButtonDisabled || i("back", v);
    };
    return (v, g) => (l(), n("div", ba, [
      e.enableBackButton ? (l(), w(V(e.backButtonComponent), {
        key: 0,
        href: e.backButtonUrl,
        class: y([
          "mp-button",
          "mp-button--back",
          `mp-button--${e.size}`,
          {
            "mp-button--disabled": e.backButtonDisabled
          }
        ]),
        onClick: d
      }, {
        default: p(() => [
          s("span", ya, [
            s("span", va, [
              e.backIcon && e.backIcon !== "none" ? (l(), n("span", ka, [
                C(A, {
                  icon: e.backIcon,
                  type: "regular",
                  size: "auto"
                }, null, 8, ["icon"])
              ])) : u("", !0)
            ]),
            v.$slots.backText || e.backText ? c(v.$slots, "backText", {
              key: 0,
              classes: ["mp-button__text"]
            }, () => [
              s("span", {
                class: "mp-button__text mp-button__text--default",
                innerHTML: e.backText
              }, null, 8, _a)
            ], !0) : u("", !0)
          ])
        ]),
        _: 3
      }, 8, ["href", "class"])) : u("", !0),
      s("div", Sa, [
        (l(), w(V(e.component), {
          href: e.url,
          class: y([
            "mp-button",
            `mp-button--${e.size}`,
            `mp-button--${e.buttonType}`,
            {
              "mp-button--disabled": e.disabled,
              "mp-button--full-width": e.fullWidth,
              "mp-button--fit-width-mobile": e.fitWidthMobile
            }
          ]),
          onClick: r
        }, {
          default: p(() => [
            s("span", {
              class: y(["mp-button__inner", [`mp-button__inner--${e.textAlignment}`]])
            }, [
              e.iconLeft && e.iconLeft !== "none" && e.buttonType !== "link" ? (l(), n("span", pa, [
                C(A, {
                  icon: e.iconLeft,
                  type: "regular",
                  size: "auto"
                }, null, 8, ["icon"])
              ])) : u("", !0),
              v.$slots.text || e.text ? c(v.$slots, "text", {
                key: 1,
                classes: ["mp-button__text"]
              }, () => [
                s("span", {
                  class: "mp-button__text mp-button__text--default",
                  innerHTML: e.text
                }, null, 8, Ca)
              ], !0) : u("", !0),
              e.iconRight && e.iconRight !== "none" && e.buttonType !== "link" ? (l(), n("span", $a, [
                C(A, {
                  icon: e.iconRight,
                  type: "regular",
                  size: "auto"
                }, null, 8, ["icon"])
              ])) : u("", !0)
            ], 2)
          ]),
          _: 3
        }, 8, ["href", "class"])),
        e.enableUnderline ? (l(), n("div", {
          key: 0,
          class: y([
            "mp-button__underline",
            `mp-button__underline--${e.underlineAlignment}`,
            {
              "mp-button__underline--full-width": e.fullWidth
            }
          ])
        }, [
          C(A, {
            icon: e.underlineIcon,
            type: "regular",
            size: "auto"
          }, null, 8, ["icon"]),
          c(v.$slots, "underlineText", { classes: ["mp-button__underline-text"] }, () => [
            s("span", qa, m(e.underlineText), 1)
          ], !0)
        ], 2)) : u("", !0)
      ])
    ]));
  }
}, F = /* @__PURE__ */ $(Pa, [["__scopeId", "data-v-d750176c"]]), wa = { class: "card-image-small-container" }, Ia = ["src", "alt"], xa = { class: "card-image-small__inner" }, La = { class: "card-image-small__content" }, Ta = {
  key: 0,
  class: "card-image-small__header u-bold"
}, Ea = {
  key: 0,
  class: "card-image-small__date"
}, Aa = {
  key: 0,
  class: "card-image-small__sub-header u-bold"
}, Ma = {
  key: 0,
  class: "card-image-small__paragraph"
}, Ba = {
  key: 0,
  class: "card-image-small__paragraph-tiny u-tiny-text"
}, Ha = {
  key: 0,
  class: "card-image-small__price"
}, za = {
  __name: "ds-organism-card-image-small",
  props: {
    direction: {
      type: String,
      required: !0,
      default: ""
    },
    alignment: {
      type: String,
      required: !0,
      default: ""
    },
    buttonType: {
      type: String,
      required: !1,
      default: ""
    },
    mediaFormat: {
      type: String,
      required: !1,
      default: "fit"
    },
    enableDropShadow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    enableArrow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    media: {
      type: String,
      required: !0,
      default: ""
    },
    alt: {
      type: String,
      required: !1,
      default: ""
    },
    buttonLink: {
      type: String,
      required: !1,
      default: ""
    },
    header: {
      type: String,
      required: !1,
      default: null
    },
    subHeader: {
      type: String,
      required: !1,
      default: null
    },
    date: {
      type: String,
      required: !1,
      default: null
    },
    paragraph: {
      type: String,
      required: !1,
      default: null
    },
    paragraphTiny: {
      type: String,
      required: !1,
      default: null
    },
    price: {
      type: String,
      required: !1,
      default: null
    },
    button: {
      type: String,
      required: !1,
      default: null
    },
    border: {
      type: String,
      required: !1,
      default: ""
    },
    background: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((a) => ({
      "3055ec49": t.background,
      "24605e72": t.border
    }));
    const t = e;
    return (a, i) => (l(), n("section", wa, [
      s("div", {
        class: y([
          "card-image-small",
          `card-image-small--${e.direction}`,
          `card-image-small--${e.alignment}`,
          {
            "card-image-small--drop-shadow": e.enableDropShadow
          }
        ])
      }, [
        c(a.$slots, "media", { classes: ["card-image-small__media"] }, () => [
          e.media ? (l(), n("img", {
            key: 0,
            class: y([
              "card-image-small__media",
              `card-image-small__media--${e.mediaFormat}`
            ]),
            src: e.media,
            alt: e.alt
          }, null, 10, Ia)) : u("", !0)
        ], !0),
        s("div", xa, [
          s("div", La, [
            c(a.$slots, "header", { classes: ["card-image-small__header"] }, () => [
              e.header ? (l(), n("h4", Ta, m(e.header), 1)) : u("", !0)
            ], !0),
            c(a.$slots, "date", { classes: ["card-image-small__date"] }, () => [
              e.date ? (l(), n("p", Ea, m(e.date), 1)) : u("", !0)
            ], !0),
            c(a.$slots, "subHeader", { classes: ["card-image-small__sub-header"] }, () => [
              e.subHeader ? (l(), n("p", Aa, m(e.subHeader), 1)) : u("", !0)
            ], !0),
            c(a.$slots, "paragraph", { classes: ["card-image-small__paragraph"] }, () => [
              e.paragraph ? (l(), n("p", Ma, m(e.paragraph), 1)) : u("", !0)
            ], !0),
            c(a.$slots, "paragraphTiny", { classes: ["card-image-small__paragraph-tiny"] }, () => [
              e.paragraphTiny ? (l(), n("p", Ba, m(e.paragraphTiny), 1)) : u("", !0)
            ], !0),
            c(a.$slots, "price", { classes: ["card-image-small__price"] }, () => [
              e.price ? (l(), n("h5", Ha, m(e.price), 1)) : u("", !0)
            ], !0)
          ]),
          c(a.$slots, "actions", {}, () => [
            C(F, {
              "icon-right": e.enableArrow ? "arrow-right" : "none",
              text: e.button,
              size: "small",
              "button-type": e.buttonType,
              "full-width": !0,
              link: e.buttonLink ?? "",
              onClick: i[0] || (i[0] = () => e.buttonLink ? "" : console.log("Button clicked"))
            }, null, 8, ["icon-right", "text", "button-type", "link"])
          ], !0)
        ])
      ], 2)
    ]));
  }
}, $i = /* @__PURE__ */ $(za, [["__scopeId", "data-v-8ef98c84"]]), Da = ["innerHTML"], Ra = ["innerHTML"], Na = ["innerHTML"], Ua = {
  __name: "ds-atom-heading",
  props: {
    alignment: {
      type: String,
      required: !1,
      default: "left"
    },
    enableDivider: {
      type: Boolean,
      required: !1,
      default: !1
    },
    topSubtitle: {
      type: String,
      required: !1,
      default: null
    },
    heading: {
      type: String,
      required: !1,
      default: null
    },
    subtitle: {
      type: String,
      required: !1,
      default: null
    },
    topSubtitleColor: {
      type: String,
      required: !1,
      default: ""
    },
    headingColor: {
      type: String,
      required: !1,
      default: ""
    },
    subtitleColor: {
      type: String,
      required: !1,
      default: ""
    },
    dividerColor: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((a) => ({
      "3e01f52f": t.topSubtitleColor,
      "1bcc795a": t.headingColor,
      bd4b531c: t.subtitleColor,
      "6f3c7aa3": t.dividerColor
    }));
    const t = e;
    return (a, i) => (l(), n("div", {
      class: y([
        "heading",
        `heading--align-${e.alignment}`,
        { "heading--divider": e.enableDivider }
      ])
    }, [
      c(a.$slots, "topSubtitle", { classes: ["heading__top-subtitle"] }, () => [
        e.topSubtitle ? (l(), n("span", {
          key: 0,
          class: "heading__top-subtitle u-heading-4",
          innerHTML: e.topSubtitle
        }, null, 8, Da)) : u("", !0)
      ], !0),
      c(a.$slots, "heading", { classes: ["heading__heading"] }, () => [
        e.heading ? (l(), n("h2", {
          key: 0,
          class: "heading__heading",
          innerHTML: e.heading
        }, null, 8, Ra)) : u("", !0)
      ], !0),
      c(a.$slots, "subtitle", { classes: ["heading__subtitle"] }, () => [
        e.subtitle ? (l(), n("span", {
          key: 0,
          class: "heading__subtitle u-heading-4",
          innerHTML: e.subtitle
        }, null, 8, Na)) : u("", !0)
      ], !0)
    ], 2));
  }
}, qi = /* @__PURE__ */ $(Ua, [["__scopeId", "data-v-83c0f4e4"]]), Va = ["for"], Ka = {
  key: 1,
  class: "mp-form-field__footer"
}, Oa = {
  key: 0,
  class: "mp-form-field__error u-tiny-text"
}, Z = {
  __name: "ds-atom-form-field",
  props: {
    label: {
      type: String,
      required: !1,
      default: ""
    },
    valid: {
      type: Boolean,
      required: !1,
      default: !0
    },
    error: {
      type: String,
      required: !1,
      default: ""
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, a) => (l(), n("div", {
      class: y(["mp-form-field", {
        "mp-form-field--error": e.valid === !1
      }])
    }, [
      e.label ? (l(), n("label", {
        key: 0,
        class: "mp-form-field__label u-tiny-text u-bold",
        for: e.id
      }, m(e.label), 9, Va)) : u("", !0),
      c(t.$slots, "default"),
      e.error || t.$slots.info ? (l(), n("div", Ka, [
        e.valid === !1 ? (l(), n("div", Oa, m(e.error), 1)) : u("", !0),
        c(t.$slots, "info")
      ])) : u("", !0)
    ], 2));
  }
}, Fa = {
  key: 0,
  class: "mp-input-element__prefix"
}, Ga = {
  key: 1,
  class: "mp-input-element__icon"
}, Ya = ["id", "name", "type", "placeholder", "disabled", "value"], Xa = {
  key: 2,
  class: "mp-input-element__suffix"
}, Pi = {
  __name: "ds-atom-input",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "small"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    mask: {
      type: String,
      default: ""
    },
    validation: {
      type: String,
      default: ""
    }
  },
  emits: ["updateValue", "updateValidation", "blur"],
  setup(e, { emit: t }) {
    const a = t, i = e, r = L(null), d = (f) => {
      let o = Pe(i.mask, f.target);
      a("updateValue", o), f.target.value !== o && (f.target.value = o);
    };
    O(() => i.value, (f) => {
      r.value.value = f;
    });
    const v = (f) => {
      const o = J(i.value, i.validation);
      o !== i.isValid && a("updateValidation", o), a("blur", f);
    }, g = (f) => {
      a("updateValidation", null), a("focus", f);
    };
    return (f, o) => (l(), w(Z, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: p(() => [
        s("div", {
          class: y(["mp-input-element", {
            "mp-input-element--has-icon": e.icon,
            "mp-input-element--disabled": e.disabled,
            [`mp-input-element--${e.size}`]: !0
          }])
        }, [
          e.prefix ? (l(), n("div", Fa, [
            s("span", null, m(e.prefix), 1)
          ])) : e.icon ? (l(), n("div", Ga, [
            C(A, {
              icon: e.icon,
              type: "regular",
              size: "auto"
            }, null, 8, ["icon"])
          ])) : u("", !0),
          s("input", {
            id: e.id,
            ref_key: "input",
            ref: r,
            class: "mp-input-element__input",
            name: e.name,
            type: e.type,
            placeholder: e.placeholder,
            disabled: e.disabled,
            value: e.value,
            onInput: de(d, ["prevent"]),
            onFocus: g,
            onBlur: v
          }, null, 40, Ya),
          e.suffix ? (l(), n("div", Xa, [
            s("span", null, m(e.suffix), 1)
          ])) : u("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, Wa = ["tabindex"], ja = { class: "select-element__field" }, Ja = ["id", "tabindex", "value", "name"], Qa = { class: "select-element__expand" }, Za = ["value", "onClick"], el = { class: "select-element__list-item-label" }, wi = {
  __name: "ds-atom-select",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    search: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["updateValue", "updateValidation", "updateSearchValue", "blur"],
  setup(e, { emit: t }) {
    const a = t, i = e, r = L(!1), d = L(null), v = L(null), g = L(null), f = L(""), o = L(-1), x = L({
      top: !1,
      bottom: !1
    }), h = z(() => i.search ? v.value : d.value), q = (b) => {
      if (!r.value) return;
      if (b.relatedTarget === d.value || d.value.contains(b.relatedTarget)) {
        b.preventDefault(), d.value.focus();
        return;
      }
      r.value = !1;
      const P = J(i.value, "notEmpty");
      P !== i.isValid && a("updateValidation", P), a("blur", b);
    }, k = (b) => {
      r.value = !0, a("updateValidation", null), N(), i.search || d.value.focus();
    }, S = (b) => {
      b ? a("updateValue", b.value) : a("updateValidation", !1), d.value.blur();
    }, G = (b) => {
      b.preventDefault(), i.search && (f.value = b.target.value, a("updateSearchValue", b.target.value));
    };
    O(() => i.options, (b) => {
      o.value = b.findIndex((P) => P.value === i.value), N();
    }), O(() => i.value, (b) => {
      if (!b)
        return;
      const P = i.options.find((E) => E.value === b);
      f.value = P.label || b, o.value = i.options.findIndex((E) => E.value === b), i.search && a("updateSearchValue", f.value);
      const T = J(i.value, "notEmpty");
      T !== i.isValid && a("updateValidation", T);
    });
    const Y = () => {
      typeof window < "u" && typeof document < "u" && document.addEventListener("keydown", (b) => {
        r.value && (b.key === "Escape" ? (r.value = !1, h.value.blur()) : b.key === "ArrowDown" ? (o.value = o.value !== i.options.length - 1 ? o.value + 1 : 0, H()) : b.key === "ArrowUp" ? (o.value = o.value !== 0 ? o.value - 1 : i.options.length - 1, H()) : b.key === "Enter" && (r.value = !1, h.value.blur(), S(i.options[o.value])));
      });
    }, H = () => {
      const b = d.value.querySelector(".select-element__list"), P = b.querySelectorAll(".select-element__list-item")[o.value];
      b.scrollTop = P.offsetTop;
    }, N = () => {
      fe(() => {
        console.log(`bottom: ${g.value.scrollTop < g.value.scrollHeight - g.value.clientHeight - 20} && ${g.value.scrollHeight > g.value.clientHeight}`), x.value = {
          top: g.value.scrollTop > 20,
          bottom: g.value.scrollTop < g.value.scrollHeight - g.value.clientHeight - 20 && g.value.scrollHeight > g.value.clientHeight
        };
      });
    };
    return Y(), (b, P) => (l(), w(Z, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: p(() => [
        s("div", {
          ref_key: "element",
          ref: d,
          tabindex: e.search ? -1 : 0,
          class: y(["select-element", {
            "select-element--disabled": e.disabled,
            "select-element--active": r.value,
            "select-element--search": e.search,
            [`select-element--${e.size}`]: !0,
            [`select-element--id-${e.id}`]: !0
          }]),
          onFocus: k,
          onBlur: q
        }, [
          s("div", ja, [
            s("input", {
              id: e.id,
              ref_key: "textField",
              ref: v,
              tabindex: e.search ? null : -1,
              value: f.value,
              type: "search",
              name: e.name,
              class: "select-element__field-input",
              placeholder: " ",
              autocomplete: "nope",
              onFocus: k,
              onInput: G,
              onFocusout: P[0] || (P[0] = (...T) => b.focusOut && b.focusOut(...T)),
              onBlur: q
            }, null, 40, Ja),
            ae(s("p", { class: "select-element__placeholder" }, m(e.placeholder), 513), [
              [le, !f.value]
            ]),
            s("div", Qa, [
              C(A, {
                class: "select-element__expand-icon",
                icon: "chevron-down",
                type: "regular",
                size: "auto"
              })
            ])
          ]),
          ae(s("ul", {
            ref_key: "list",
            ref: g,
            class: y(["select-element__list", {
              "select-element__list--shadow-top": x.value.top,
              "select-element__list--shadow-bottom": x.value.bottom
            }]),
            tabindex: "-1",
            onScroll: N
          }, [
            (l(!0), n(B, null, D(e.options, (T, E) => (l(), n("li", {
              key: E,
              value: T.value,
              class: y(["select-element__list-item", {
                "select-element__list-item--selected": E === o.value
              }]),
              onClick: (X) => S(T)
            }, [
              s("span", el, m(T.label), 1)
            ], 10, Za))), 128))
          ], 34), [
            [le, r.value]
          ])
        ], 42, Wa)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, tl = ["id", "name", "placeholder", "disabled", "value"], Ii = {
  __name: "ds-atom-textarea",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    }
  },
  emits: ["updateValue", "updateValidation", "focus", "blur"],
  setup(e, { emit: t }) {
    const a = t, i = e, r = L(null), d = (f) => {
      let o = f.target.value;
      a("updateValue", o), r.value.value = i.value;
    };
    O(() => i.value, (f) => {
      r.value.value = f;
    });
    const v = (f) => {
      const o = !!i.value;
      o !== i.isValid && a("updateValidation", o), a("blur", f);
    }, g = (f) => {
      a("updateValidation", null), a("focus", f);
    };
    return (f, o) => (l(), w(Z, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: p(() => [
        s("textarea", {
          id: e.id,
          ref_key: "textarea",
          ref: r,
          class: "textarea-element u-paragraph",
          name: e.name,
          placeholder: e.placeholder,
          disabled: e.disabled,
          value: e.value,
          onInput: de(d, ["prevent"]),
          onFocus: g,
          onBlur: v
        }, null, 40, tl)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, al = { class: "item-icon__content" }, ll = { class: "item-icon__text" }, il = { class: "item-icon__text-heading u-heading-4" }, nl = { class: "item-icon__text-paragraph u-paragraph" }, rl = { class: "item-icon__text-paragraph-tiny u-tiny-text" }, sl = {
  __name: "ds-molecule-item-icon",
  props: {
    alignment: {
      type: String,
      required: !1,
      default: "left"
    },
    heading: {
      type: String,
      required: !0
    },
    clickableHeading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    clickableHeadingUrl: {
      type: String,
      required: !1,
      default: ""
    },
    paragraph: {
      type: String,
      required: !0
    },
    paragraphTiny: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = R();
    return (a, i) => (l(), n("li", {
      class: y([
        "item-icon",
        `item-icon--${e.alignment}`
      ])
    }, [
      e.icon || _(t).icon ? c(a.$slots, "icon", {
        key: 0,
        classes: ["item-icon__icon"]
      }, () => [
        e.icon ? (l(), w(A, {
          key: 0,
          class: "item-icon__icon",
          icon: e.icon,
          type: "regular",
          size: "24"
        }, null, 8, ["icon"])) : u("", !0)
      ], !0) : u("", !0),
      s("div", al, [
        s("div", ll, [
          e.clickableHeading && (e.heading || _(t).heading) ? (l(), w(F, {
            key: 0,
            class: "item-icon__text-button",
            "button-type": "text",
            size: "medium",
            "text-alignment": e.alignment,
            component: "a",
            url: e.clickableHeadingUrl,
            "fit-width-mobile": ""
          }, {
            text: p(({ classes: r }) => [
              c(a.$slots, "heading", {
                classes: ["item-icon__text-heading", r]
              }, () => [
                s("h4", {
                  class: y([r, "item-icon__text-heading u-heading-4"])
                }, m(e.heading), 3)
              ], !0)
            ]),
            _: 3
          }, 8, ["text-alignment", "url"])) : u("", !0),
          !e.clickableHeading && (e.heading || _(t).heading) ? c(a.$slots, "heading", {
            key: 1,
            classes: ["item-icon__text-heading"]
          }, () => [
            s("h4", il, m(e.heading), 1)
          ], !0) : u("", !0),
          e.paragraph || _(t).paragraph ? c(a.$slots, "paragraph", {
            key: 2,
            classes: ["item-icon__text-paragraph"]
          }, () => [
            s("p", nl, m(e.paragraph), 1)
          ], !0) : u("", !0),
          e.paragraphTiny || _(t).paragraphTiny ? c(a.$slots, "paragraphTiny", {
            key: 3,
            classes: ["item-icon__text-paragraph-tiny"]
          }, () => [
            s("p", rl, m(e.paragraphTiny), 1)
          ], !0) : u("", !0)
        ]),
        c(a.$slots, "action", { classes: ["item-icon__action"] }, void 0, !0)
      ])
    ], 2));
  }
}, xi = /* @__PURE__ */ $(sl, [["__scopeId", "data-v-302ebe25"]]), ol = (e) => {
  if (typeof document > "u") return e.replace(/<\/?[^>]+>/ig, "");
}, ul = { class: "magazine-article-card-container" }, cl = {
  key: 0,
  class: "magazine-article-card__image-container"
}, dl = ["src", "alt"], fl = { class: "magazine-article-card__content" }, gl = { class: "magazine-article-card__content-main" }, ml = {
  key: 0,
  class: "magazine-article-card__content-title u-heading-4"
}, hl = {
  key: 0,
  class: "u-regular magazine-article-card__content-date"
}, bl = {
  key: 0,
  class: "u-regular magazine-article-card__content-description"
}, yl = {
  __name: "ds-molecule-magazine-article-card",
  props: {
    cardLinkTag: {
      type: String,
      required: !1,
      default: "a"
    },
    url: {
      type: String,
      required: !1,
      default: ""
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    description: {
      type: String,
      required: !1,
      default: ""
    },
    image: {
      type: Object,
      required: !1,
      default: null
    },
    date: {
      type: String,
      required: !1,
      default: ""
    },
    background: {
      type: String,
      required: !1,
      default: ""
    },
    titleColor: {
      type: String,
      required: !1,
      default: ""
    },
    titleHoverColor: {
      type: String,
      required: !1,
      default: ""
    },
    textColor: {
      type: String,
      required: !1,
      default: ""
    },
    dateColor: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((a) => ({
      "082143d2": t.background,
      "276e7ae2": t.titleColor,
      "480663db": t.titleHoverColor,
      aab049dc: t.textColor,
      "4caacd9e": t.dateColor
    }));
    const t = e;
    return (a, i) => (l(), n("section", ul, [
      e.url ? (l(), w(V(e.cardLinkTag ?? "a"), {
        key: 0,
        class: "magazine-article-card",
        href: e.url
      }, {
        default: p(() => [
          c(a.$slots, "image", { classes: ["magazine-article-card__image"] }, () => {
            var r;
            return [
              (r = e.image) != null && r.src ? (l(), n("div", cl, [
                s("img", {
                  class: "magazine-article-card__image",
                  src: e.image.src,
                  alt: e.image.alt ?? ""
                }, null, 8, dl)
              ])) : u("", !0)
            ];
          }, !0),
          s("div", fl, [
            s("div", gl, [
              c(a.$slots, "title", { classes: ["magazine-article-card__content-title"] }, () => [
                e.title ? (l(), n("h3", ml, m(e.title), 1)) : u("", !0)
              ], !0),
              c(a.$slots, "date", { classes: ["magazine-article-card__content-date"] }, () => [
                e.date ? (l(), n("p", hl, m(e.date), 1)) : u("", !0)
              ], !0)
            ]),
            c(a.$slots, "description", { classes: ["magazine-article-card__content-description"] }, () => [
              e.description ? (l(), n("p", bl, m(_(ol)(e.description)), 1)) : u("", !0)
            ], !0)
          ])
        ]),
        _: 3
      }, 8, ["href"])) : u("", !0)
    ]));
  }
}, vl = /* @__PURE__ */ $(yl, [["__scopeId", "data-v-7ea03f55"]]), kl = { class: "mp-trust-container" }, _l = { class: "u-tiny-text mp-trust__text" }, Sl = ["href"], pl = ["src", "alt"], Cl = {
  __name: "ds-molecule-trust",
  props: {
    type: {
      type: String,
      required: !1,
      default: "rounded"
    },
    stars: {
      type: Number,
      required: !0
    },
    showRating: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showText: {
      type: Boolean,
      required: !1,
      default: !1
    },
    text: {
      type: String,
      required: !1,
      default: null
    },
    textClickable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    textUrl: {
      type: String,
      required: !1,
      default: null
    },
    showDividers: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showLogo: {
      type: Boolean,
      required: !1,
      default: !1
    },
    background: {
      type: String,
      required: !1,
      default: null
    },
    darkMode: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(e) {
    I((r) => ({
      cba9603e: t.background
    }));
    const t = e, a = R(), i = z(() => t.type === "rounded" ? null : t.darkMode ? new URL((/* @__PURE__ */ Object.assign({ "../../../../assets/logos/feedback-company-darkmode.svg": re, "../../../../assets/logos/trustpilot-darkmode.svg": ne, "../../../../assets/logos/yelp-darkmode.svg": ie }))[`../../../../assets/logos/${t.type}-darkmode.svg`], import.meta.url).href : new URL((/* @__PURE__ */ Object.assign({ "../../../../assets/logos/facebook.svg": na, "../../../../assets/logos/feedback-company-darkmode.svg": re, "../../../../assets/logos/feedback-company.svg": ia, "../../../../assets/logos/google.svg": la, "../../../../assets/logos/trustpilot-darkmode.svg": ne, "../../../../assets/logos/trustpilot.svg": aa, "../../../../assets/logos/yelp-darkmode.svg": ie, "../../../../assets/logos/yelp.svg": ta }))[`../../../../assets/logos/${t.type}.svg`], import.meta.url).href);
    return (r, d) => (l(), n("div", kl, [
      s("article", {
        class: y([
          "mp-trust",
          {
            "mp-trust--background": e.background,
            "mp-trust--dark-mode": e.darkMode
          }
        ])
      }, [
        C(we, {
          type: e.type,
          stars: e.stars,
          size: "s",
          "show-rating": e.showRating,
          "dark-mode": e.darkMode
        }, null, 8, ["type", "stars", "show-rating", "dark-mode"]),
        e.text || _(a).text ? (l(), n("div", {
          key: 0,
          class: y([
            "mp-trust__text-wrapper",
            {
              "mp-trust__text-wrapper--divider": e.showDividers
            }
          ])
        }, [
          e.textClickable ? u("", !0) : c(r.$slots, "text", {
            key: 0,
            classes: "mp-trust__text"
          }, () => [
            s("p", _l, m(e.text), 1)
          ], !0),
          e.textClickable && e.textUrl ? c(r.$slots, "text", {
            key: 1,
            classes: "mp-trust__text mp-trust__text--clickable"
          }, () => [
            s("a", {
              class: "mp-trust__text mp-trust__text--clickable u-tiny-text",
              href: e.textUrl
            }, m(e.text), 9, Sl)
          ], !0) : u("", !0)
        ], 2)) : u("", !0),
        e.showLogo && (i.value || _(a).logo) ? (l(), n("div", {
          key: 1,
          class: y([
            "mp-trust__logo-wrapper",
            {
              "mp-trust__logo-wrapper--divider": e.showDividers
            }
          ])
        }, [
          c(r.$slots, "logo", { class: "mp-trust__logo" }, () => [
            s("img", {
              class: "mp-trust__logo",
              src: i.value,
              alt: e.type
            }, null, 8, pl)
          ], !0)
        ], 2)) : u("", !0)
      ], 2)
    ]));
  }
}, Li = /* @__PURE__ */ $(Cl, [["__scopeId", "data-v-ffb7c2fa"]]), $l = { class: "card-icon-container" }, ql = { class: "card-icon" }, Pl = { class: "card-icon__content" }, wl = ["innerHTML"], Il = ["innerHTML"], xl = ["innerHTML"], Ll = {
  __name: "ds-organism-card-icon",
  props: {
    icon: {
      type: String,
      required: !0,
      default: ""
    },
    header: {
      type: String,
      required: !1,
      default: null
    },
    subheader: {
      type: String,
      required: !1,
      default: null
    },
    paragraph: {
      type: String,
      required: !1,
      default: null
    },
    background: {
      type: String,
      required: !1,
      default: ""
    },
    iconColor: {
      type: String,
      required: !1,
      default: ""
    },
    headerColor: {
      type: String,
      required: !1,
      default: ""
    },
    headerHoverColor: {
      type: String,
      required: !1,
      default: ""
    },
    borderColor: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    I((a) => ({
      "3de20d7f": t.background,
      "0af85ff9": t.iconColor
    }));
    const t = e;
    return R(), (a, i) => (l(), n("div", $l, [
      s("section", ql, [
        c(a.$slots, "icon", { classes: ["card-icon__icon"] }, () => [
          C(A, {
            icon: e.icon,
            class: "card-icon__icon",
            type: "solid",
            size: "auto"
          }, null, 8, ["icon"])
        ], !0),
        s("div", Pl, [
          c(a.$slots, "header", { classes: ["card-icon__header"] }, () => [
            s("div", {
              class: "card-icon__header",
              innerHTML: e.header
            }, null, 8, wl)
          ], !0),
          c(a.$slots, "subHeader", { classes: ["card-icon__sub-header"] }, () => [
            s("div", {
              class: "card-icon__sub-header",
              innerHTML: e.subheader
            }, null, 8, Il)
          ], !0),
          c(a.$slots, "paragraph", { classes: ["card-icon__paragraph"] }, () => [
            s("div", {
              classes: ["card-icon__paragraph"],
              innerHTML: e.paragraph
            }, null, 8, xl)
          ], !0)
        ])
      ])
    ]));
  }
}, Ti = /* @__PURE__ */ $(Ll, [["__scopeId", "data-v-b9ead394"]]);
function Tl(e) {
  const t = parseInt(window.getComputedStyle(e).lineHeight);
  return e.clientHeight > t;
}
const El = { class: "content-column-checkmarks-container" }, Al = { class: "content-column-checkmarks__inner" }, Ml = {
  key: 0,
  class: "content-column-checkmarks__heading"
}, Bl = {
  key: 0,
  class: "content-column-checkmarks__subheading"
}, Hl = ["innerHTML"], zl = ["href"], Dl = {
  __name: "ds-organism-content-column-checkmarks",
  props: {
    items: {
      type: Array,
      required: !0
    },
    heading: {
      type: String,
      required: !1,
      default: null
    },
    subheading: {
      type: String,
      required: !1,
      default: null
    },
    headingsPosition: {
      type: String,
      required: !1,
      default: "left"
    },
    columnCount: {
      type: String,
      required: !1,
      default: "1"
    },
    mediaSize: {
      type: String,
      required: !1,
      default: "small"
    },
    mediaPosition: {
      type: String,
      required: !1,
      default: "above"
    },
    turnOnBackground: {
      type: Boolean,
      required: !1,
      default: !1
    },
    background: {
      type: String,
      required: !1,
      default: null
    },
    iconColor: {
      type: String,
      required: !1,
      default: null
    },
    headingColor: {
      type: String,
      required: !1,
      default: null
    },
    subheadingColor: {
      type: String,
      required: !1,
      default: null
    },
    titleColor: {
      type: String,
      required: !1,
      default: null
    },
    titleHoverColor: {
      type: String,
      required: !1,
      default: null
    },
    titleActiveColor: {
      type: String,
      required: !1,
      default: null
    },
    textColor: {
      type: String,
      required: !1,
      default: null
    },
    buttonColor: {
      type: String,
      required: !1,
      default: null
    },
    buttonHoverColor: {
      type: String,
      required: !1,
      default: null
    },
    buttonActiveColor: {
      type: String,
      required: !1,
      default: null
    }
  },
  setup(e) {
    I((o) => ({
      "2b4bd0bb": d.value,
      37510843: t.iconColor,
      c6c32316: t.background,
      "65ca1608": t.headingColor,
      "13052bda": t.subheadingColor,
      fe74259c: t.titleColor,
      "894d31d0": t.titleHoverColor,
      "4c59500f": t.textColor,
      "2a51d6ea": t.buttonColor,
      "23d2d060": t.buttonHoverColor,
      "5303da44": t.buttonActiveColor
    }));
    const t = e, a = R(), i = L([]), r = L([]), d = z(
      () => Math.min(t.items.length, parseInt(t.columnCount))
    ), v = {
      checkmark: "check",
      "checkmark-circle": "circle-check",
      "circle-info": "circle-info",
      heart: "heart",
      star: "star"
    }, g = z(() => t.mediaSize === "small" ? "24" : t.mediaSize === "medium" ? "32" : t.mediaSize === "large" ? "40" : "auto");
    $e(() => {
      fe(() => {
        i.value.forEach((o, x) => {
          Tl(o) && (r.value[x] = !0);
        });
      });
    });
    const f = (o) => r.value[o];
    return (o, x) => (l(), n("article", El, [
      s("div", {
        class: y([
          "content-column-checkmarks",
          { "content-column-checkmarks--background": e.turnOnBackground }
        ])
      }, [
        s("div", Al, [
          e.heading || e.subheading || _(a).heading || _(a).subheading ? (l(), n("div", {
            key: 0,
            class: y([
              "content-column-checkmarks__header",
              `content-column-checkmarks__header--${e.headingsPosition}`
            ])
          }, [
            c(o.$slots, "heading", {
              classes: [
                "content-column-checkmarks__heading",
                `content-column-checkmarks__header--${e.headingsPosition}`
              ]
            }, () => [
              e.heading ? (l(), n("h3", Ml, m(e.heading), 1)) : u("", !0)
            ], !0),
            c(o.$slots, "subheading", { classes: ["content-column-checkmarks__subheading"] }, () => [
              e.subheading ? (l(), n("h4", Bl, m(e.subheading), 1)) : u("", !0)
            ], !0)
          ], 2)) : u("", !0),
          s("ul", {
            class: y([
              "content-column-checkmarks__list",
              `content-column-checkmarks__list--${e.mediaPosition}`
            ])
          }, [
            (l(!0), n(B, null, D(e.items, (h, q) => (l(), n("li", {
              key: q,
              class: "content-column-checkmarks__item"
            }, [
              c(o.$slots, "icon", {
                item: h,
                classes: [
                  "content-column-checkmarks__item-image",
                  `content-column-checkmarks__item-image--${e.mediaSize}`
                ]
              }, () => [
                h.icon && h.mediaType === "icon" ? (l(), w(A, {
                  key: 0,
                  icon: v[h.icon],
                  type: v[h.icon] === "circle-info" ? "solid" : "regular",
                  size: g.value,
                  class: y([
                    "content-column-checkmarks__item-image"
                  ])
                }, null, 8, ["icon", "type", "size"])) : u("", !0)
              ], !0),
              s("div", {
                class: y([
                  "content-column-checkmarks__item-content",
                  h.title && !h.buttonLabel && !h.text ? "content-column-checkmarks__item-content--only-title" : ""
                ])
              }, [
                h.title ? c(o.$slots, "itemTitle", {
                  key: 0,
                  classes: [
                    "content-column-checkmarks__item-title",
                    { "content-column-checkmarks__item-title--link": h.url }
                  ],
                  title: h.title,
                  url: h.url ?? ""
                }, () => [
                  (l(), w(V(h.url ? "a" : "h4"), {
                    href: h.url,
                    class: y([
                      "content-column-checkmarks__item-title u-heading-4 u-bold",
                      h.url ? "content-column-checkmarks__item-title--link" : ""
                    ])
                  }, {
                    default: p(() => [
                      j(m(h.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["href", "class"]))
                ], !0) : u("", !0),
                h.text ? c(o.$slots, "itemText", {
                  key: 1,
                  classes: [
                    "content-column-checkmarks__item-text",
                    { "content-column-checkmarks__item-text--multiline": f(q) }
                  ],
                  text: h.text
                }, () => [
                  s("div", {
                    ref_for: !0,
                    ref_key: "itemTextRefs",
                    ref: i,
                    class: y([
                      "content-column-checkmarks__item-text",
                      { "content-column-checkmarks__item-text--multiline": f(q) }
                    ]),
                    innerHTML: h.text
                  }, null, 10, Hl)
                ], !0) : u("", !0),
                h.hideButton ? u("", !0) : c(o.$slots, "button", {
                  key: 2,
                  classes: ["content-column-checkmarks__item-button"]
                }, () => [
                  h.buttonLabel && h.buttonUrl ? (l(), n("a", {
                    key: 0,
                    class: "content-column-checkmarks__item-button",
                    href: h.buttonUrl
                  }, m(h.buttonLabel), 9, zl)) : u("", !0)
                ], !0)
              ], 2)
            ]))), 128))
          ], 2)
        ])
      ], 2)
    ]));
  }
}, Ei = /* @__PURE__ */ $(Dl, [["__scopeId", "data-v-378c5416"]]), Rl = { class: "cta-with-image-container" }, Nl = { class: "cta-with-image__content-left" }, Ul = {
  key: 0,
  class: "cta-with-image__heading u-heading-3 u-bold"
}, Vl = ["innerHTML"], Kl = {
  key: 0,
  class: "cta-with-image__links"
}, Ol = { class: "cta-with-image__link" }, Fl = ["href"], Gl = {
  key: 1,
  class: "cta-with-image__button-wrapper"
}, Yl = { class: "cta-with-image__content-right" }, Xl = ["src", "alt"], Wl = {
  __name: "ds-organism-cta-with-image",
  props: {
    heading: {
      type: String,
      required: !1,
      default: ""
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    links: {
      type: Array,
      required: !1,
      default: null
    },
    button: {
      type: Object,
      required: !1,
      default: null
    },
    tinyText: {
      type: String,
      required: !1,
      default: ""
    },
    image: {
      type: Object,
      required: !1,
      default: null
    },
    enableBackground: {
      type: Boolean,
      required: !1,
      default: !0
    },
    backgroundColor: {
      type: String,
      required: !1,
      default: ""
    },
    headingColor: {
      type: String,
      required: !1,
      default: ""
    },
    dividerColor: {
      type: String,
      required: !1,
      default: ""
    },
    textColor: {
      type: String,
      required: !1,
      default: ""
    },
    linkColor: {
      type: String,
      required: !1,
      default: ""
    },
    linkHoverColor: {
      type: String,
      required: !1,
      default: ""
    },
    linkActiveColor: {
      type: String,
      required: !1,
      default: ""
    },
    tinyTextColor: {
      type: String,
      required: !1,
      default: ""
    },
    buttonStyle: {
      type: String,
      required: !1,
      default: "primary"
    }
  },
  setup(e) {
    I((a) => ({
      ffeb61a6: t.backgroundColor,
      "3c317929": t.headingColor,
      e0bd0b1c: t.dividerColor,
      "154ca88e": t.textColor,
      "1b58143e": t.linkColor,
      "381f186e": t.linkHoverColor,
      d2cab80a: t.linkActiveColor,
      "3480e96e": t.tinyTextColor
    }));
    const t = e;
    return (a, i) => (l(), n("div", Rl, [
      s("article", {
        class: y([
          "cta-with-image",
          { "cta-with-image--background": e.enableBackground }
        ])
      }, [
        s("div", Nl, [
          c(a.$slots, "heading", { classes: ["cta-with-image__heading"] }, () => [
            e.heading ? (l(), n("h1", Ul, m(e.heading), 1)) : u("", !0)
          ], !0),
          i[0] || (i[0] = s("div", { class: "cta-with-image__separator" }, null, -1)),
          c(a.$slots, "text", { classes: ["cta-with-image__text"] }, () => [
            e.text ? (l(), n("div", {
              key: 0,
              class: "cta-with-image__text",
              innerHTML: e.text
            }, null, 8, Vl)) : u("", !0)
          ], !0),
          e.links ? (l(), n("ul", Kl, [
            (l(!0), n(B, null, D(e.links, (r) => (l(), n("li", Ol, [
              c(a.$slots, "linkItem", {
                link: r,
                classes: ["cta-with-image__link-text"]
              }, () => [
                s("a", {
                  class: "cta-with-image__link-text",
                  href: r.url
                }, m(r.text), 9, Fl)
              ], !0)
            ]))), 256))
          ])) : u("", !0),
          e.button ? (l(), n("div", Gl, [
            c(a.$slots, "button", { classes: ["cta-with-image__button"] }, () => [
              C(F, {
                size: "medium",
                text: e.button.text,
                url: e.button.link,
                "enable-underline": "",
                "underline-text": e.tinyText,
                "button-type": e.buttonStyle
              }, {
                underlineText: p(({ classes: r }) => [
                  c(a.$slots, "tinyText", { classes: r }, void 0, !0)
                ]),
                _: 3
              }, 8, ["text", "url", "underline-text", "button-type"])
            ], !0)
          ])) : u("", !0)
        ]),
        s("div", Yl, [
          c(a.$slots, "image", { classes: ["cta-with-image__image"] }, () => [
            e.image ? (l(), n("img", {
              key: 0,
              class: y([
                "cta-with-image__image",
                { "cta-with-image__image--full-width": e.image.src.endsWith(".svg") }
              ]),
              src: e.image.src,
              alt: e.image.alt || ""
            }, null, 10, Xl)) : u("", !0)
          ], !0)
        ])
      ], 2)
    ]));
  }
}, Ai = /* @__PURE__ */ $(Wl, [["__scopeId", "data-v-1982c951"]]), jl = { class: "icon-link-bar-container" }, Jl = { class: "icon-link-bar" }, Ql = {
  key: 1,
  class: "media-hero__share-text"
}, Zl = { class: "icon-link-bar__items" }, ei = ["href"], ti = {
  __name: "ds-organism-icon-link-bar",
  props: {
    shareText: {
      type: String,
      required: !1,
      default: ""
    },
    items: {
      type: Array,
      required: !1,
      default: () => []
    },
    iconBackgroundColor: {
      type: String,
      required: !1,
      default: null
    },
    iconColor: {
      type: String,
      required: !1,
      default: null
    }
  },
  setup(e) {
    I((i) => ({
      "5736d5e1": t.iconBackgroundColor,
      "25d32d6f": t.iconColor
    }));
    const t = e, a = R();
    return (i, r) => (l(), n("div", jl, [
      s("article", Jl, [
        _(a).shareText ? c(i.$slots, "header", {
          key: 0,
          classes: ["icon-link-bar__share-text"]
        }, void 0, !0) : e.shareText ? (l(), n("h5", Ql, m(e.shareText), 1)) : u("", !0),
        s("div", Zl, [
          (l(!0), n(B, null, D(e.items, (d) => (l(), n("a", {
            href: d.url,
            target: "_blank",
            class: "icon-link-bar__item"
          }, [
            C(A, {
              icon: d.type,
              type: "brand",
              size: "auto",
              class: y([
                "icon-link-bar__item-icon",
                `icon-link-bar__item-icon--${d.type}`
              ])
            }, null, 8, ["icon", "class"])
          ], 8, ei))), 256))
        ])
      ])
    ]));
  }
}, Mi = /* @__PURE__ */ $(ti, [["__scopeId", "data-v-f05a584b"]]), ai = { class: "list-magazine-articles-container" }, li = ["href"], ii = {
  __name: "ds-organism-list-magazine-articles",
  props: {
    heading: {
      type: String,
      required: !1,
      default: null
    },
    enableHeadingDivider: {
      type: Boolean,
      required: !1,
      default: !1
    },
    items: {
      type: Array,
      required: !0
    },
    enableItemDivider: {
      type: Boolean,
      required: !1,
      default: !1
    },
    linkUrl: {
      type: String,
      required: !1,
      default: null
    },
    linkLabel: {
      type: String,
      required: !1,
      default: null
    },
    listStyle: {
      type: String,
      required: !1,
      default: "horizontal"
    },
    background: {
      type: String,
      required: !1,
      default: null
    },
    titleColor: {
      type: String,
      required: !1,
      default: null
    },
    dividerColor: {
      type: String,
      required: !1,
      default: null
    },
    linkColor: {
      type: String,
      required: !1,
      default: null
    },
    linkHoverColor: {
      type: String,
      required: !1,
      default: null
    },
    linkActiveColor: {
      type: String,
      required: !1,
      default: null
    },
    cardStyle: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  setup(e) {
    I((i) => ({
      "3e3475db": t.background,
      "225bf498": t.titleColor,
      "4d6bdd37": t.dividerColor,
      "36d9113c": t.linkColor,
      "58ad394e": t.linkHoverColor,
      "8d12e1d4": t.linkActiveColor
    }));
    const t = e, a = R();
    return (i, r) => (l(), n("section", ai, [
      s("div", {
        class: y([
          "list-magazine-articles",
          e.background ? "list-magazine-articles--background" : ""
        ])
      }, [
        c(i.$slots, "heading", {
          classes: [
            "list-magazine-articles__heading",
            `list-magazine-articles__heading--${e.listStyle}`,
            {
              "list-magazine-articles__heading--divider": e.enableHeadingDivider
            }
          ]
        }, () => [
          e.heading ? (l(), n("h2", {
            key: 0,
            class: y([
              "list-magazine-articles__heading",
              `list-magazine-articles__heading--${e.listStyle}`,
              {
                "list-magazine-articles__heading--divider": e.enableHeadingDivider
              }
            ])
          }, m(e.heading), 3)) : u("", !0)
        ], !0),
        s("ul", {
          class: y([
            "list-magazine-articles__list",
            `list-magazine-articles__list--${e.listStyle}`,
            e.enableItemDivider ? "list-magazine-articles__list--divider" : ""
          ])
        }, [
          (l(!0), n(B, null, D(e.items, (d) => {
            var v, g, f, o, x, h, q, k;
            return l(), n("li", {
              key: d.id,
              class: "list-magazine-articles__list-item"
            }, [
              C(vl, {
                url: d.url,
                title: d.title,
                description: d.description,
                image: d.image,
                date: d.date,
                background: (v = e.cardStyle) == null ? void 0 : v.background,
                "title-color": (g = e.cardStyle) == null ? void 0 : g.titleColor,
                "title-hover-color": (f = e.cardStyle) == null ? void 0 : f.titleHoverColor,
                "text-color": (o = e.cardStyle) == null ? void 0 : o.textColor,
                "date-color": (x = e.cardStyle) == null ? void 0 : x.dateColor,
                "button-color": (h = e.cardStyle) == null ? void 0 : h.buttonColor,
                "button-hover-color": (q = e.cardStyle) == null ? void 0 : q.buttonHoverColor,
                "button-active-color": (k = e.cardStyle) == null ? void 0 : k.buttonActiveColor
              }, qe({ _: 2 }, [
                _(a).itemImage ? {
                  name: "image",
                  fn: p(({ classes: S }) => [
                    c(i.$slots, "itemImage", {
                      image: d.image,
                      classes: S
                    }, void 0, !0)
                  ]),
                  key: "0"
                } : void 0,
                _(a).itemTitle ? {
                  name: "title",
                  fn: p(({ classes: S }) => [
                    c(i.$slots, "itemTitle", {
                      title: d.title,
                      classes: S
                    }, void 0, !0)
                  ]),
                  key: "1"
                } : void 0,
                _(a).itemDate ? {
                  name: "date",
                  fn: p(({ classes: S }) => [
                    c(i.$slots, "itemDate", {
                      date: d.date,
                      classes: S
                    }, void 0, !0)
                  ]),
                  key: "2"
                } : void 0,
                _(a).itemDescription ? {
                  name: "description",
                  fn: p(({ classes: S }) => [
                    c(i.$slots, "itemDescription", {
                      description: d.description || d.alternativeDescription,
                      classes: S
                    }, void 0, !0)
                  ]),
                  key: "3"
                } : void 0
              ]), 1032, ["url", "title", "description", "image", "date", "background", "title-color", "title-hover-color", "text-color", "date-color", "button-color", "button-hover-color", "button-active-color"])
            ]);
          }), 128))
        ], 2),
        c(i.$slots, "link", { classes: ["list-magazine-articles__action"] }, () => [
          e.linkUrl && e.linkLabel ? (l(), n("a", {
            key: 0,
            href: e.linkUrl,
            target: "_self",
            class: "list-magazine-articles__action"
          }, m(e.linkLabel), 9, li)) : u("", !0)
        ], !0)
      ], 2)
    ]));
  }
}, Bi = /* @__PURE__ */ $(ii, [["__scopeId", "data-v-d537ae33"]]), ni = { class: "logo-with-button-container" }, ri = { class: "logo-with-button" }, si = ["src", "alt"], oi = { class: "logo-with-button__content" }, ui = {
  key: 0,
  class: "logo-with-button__content-title u-bold"
}, ci = {
  key: 0,
  class: "logo-with-button__content-text"
}, di = {
  __name: "ds-organism-logo-with-button",
  props: {
    image: {
      type: Object,
      required: !1,
      default: null
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    buttonText: {
      type: String,
      required: !1,
      default: ""
    },
    buttonLink: {
      type: String,
      required: !1,
      default: ""
    },
    background: {
      type: String,
      required: !1,
      default: null
    },
    borderColor: {
      type: String,
      required: !1,
      default: null
    },
    titleColor: {
      type: String,
      required: !1,
      default: null
    },
    textColor: {
      type: String,
      required: !1,
      default: null
    },
    buttonStyle: {
      type: String,
      required: !1,
      default: "secondary"
    }
  },
  setup(e) {
    I((a) => ({
      "0f3768a4": t.background,
      bf4e3c3e: t.borderColor,
      "1942313e": t.titleColor,
      "369e5800": t.textColor
    }));
    const t = e;
    return (a, i) => (l(), n("div", ni, [
      s("article", ri, [
        c(a.$slots, "image", { classes: ["logo-with-button__image"] }, () => [
          e.image ? (l(), n("img", {
            key: 0,
            class: "logo-with-button__image",
            src: e.image.src,
            alt: e.image.alt || ""
          }, null, 8, si)) : u("", !0)
        ], !0),
        s("div", oi, [
          c(a.$slots, "title", { classes: ["logo-with-button__content-title"] }, () => [
            e.title ? (l(), n("h4", ui, m(e.title), 1)) : u("", !0)
          ], !0),
          c(a.$slots, "text", { classes: ["logo-with-button__content-text"] }, () => [
            e.text ? (l(), n("p", ci, m(e.text), 1)) : u("", !0)
          ], !0)
        ]),
        c(a.$slots, "button", { classes: ["logo-with-button__button"] }, () => [
          C(F, {
            text: e.buttonText,
            url: e.buttonLink,
            "button-type": e.buttonStyle,
            size: "medium",
            "full-width": !0
          }, {
            text: p(({ classes: r }) => [
              c(a.$slots, "buttonText", { classes: r }, void 0, !0)
            ]),
            _: 3
          }, 8, ["text", "url", "button-type"])
        ], !0)
      ])
    ]));
  }
}, Hi = /* @__PURE__ */ $(di, [["__scopeId", "data-v-fdfba63f"]]);
var U = {}, W = {}, se;
function fi() {
  if (se) return W;
  se = 1;
  function e(t, a) {
    for (var i = [], r = t; r <= a; r++)
      i.push(r);
    return i;
  }
  return W.createRange = e, W;
}
var M = {}, K = {}, oe;
function he() {
  return oe || (oe = 1, K.ITEM_TYPES = {
    PAGE: "PAGE",
    ELLIPSIS: "ELLIPSIS",
    FIRST_PAGE_LINK: "FIRST_PAGE_LINK",
    PREVIOUS_PAGE_LINK: "PREVIOUS_PAGE_LINK",
    NEXT_PAGE_LINK: "NEXT_PAGE_LINK",
    LAST_PAGE_LINK: "LAST_PAGE_LINK"
  }, K.ITEM_KEYS = {
    FIRST_ELLIPSIS: -1,
    SECOND_ELLIPSIS: -2,
    FIRST_PAGE_LINK: -3,
    PREVIOUS_PAGE_LINK: -4,
    NEXT_PAGE_LINK: -5,
    LAST_PAGE_LINK: -6
  }), K;
}
var ue;
function gi() {
  if (ue) return M;
  ue = 1;
  var e = he();
  return M.createFirstEllipsis = function(t) {
    return {
      type: e.ITEM_TYPES.ELLIPSIS,
      key: e.ITEM_KEYS.FIRST_ELLIPSIS,
      value: t,
      isActive: !1
    };
  }, M.createSecondEllipsis = function(t) {
    return {
      type: e.ITEM_TYPES.ELLIPSIS,
      key: e.ITEM_KEYS.SECOND_ELLIPSIS,
      value: t,
      isActive: !1
    };
  }, M.createFirstPageLink = function(t) {
    var a = t.currentPage;
    return {
      type: e.ITEM_TYPES.FIRST_PAGE_LINK,
      key: e.ITEM_KEYS.FIRST_PAGE_LINK,
      value: 1,
      isActive: a === 1
    };
  }, M.createPreviousPageLink = function(t) {
    var a = t.currentPage;
    return {
      type: e.ITEM_TYPES.PREVIOUS_PAGE_LINK,
      key: e.ITEM_KEYS.PREVIOUS_PAGE_LINK,
      value: Math.max(1, a - 1),
      isActive: a === 1
    };
  }, M.createNextPageLink = function(t) {
    var a = t.currentPage, i = t.totalPages;
    return {
      type: e.ITEM_TYPES.NEXT_PAGE_LINK,
      key: e.ITEM_KEYS.NEXT_PAGE_LINK,
      value: Math.min(i, a + 1),
      isActive: a === i
    };
  }, M.createLastPageLink = function(t) {
    var a = t.currentPage, i = t.totalPages;
    return {
      type: e.ITEM_TYPES.LAST_PAGE_LINK,
      key: e.ITEM_KEYS.LAST_PAGE_LINK,
      value: i,
      isActive: a === i
    };
  }, M.createPageFunctionFactory = function(t) {
    var a = t.currentPage;
    return function(i) {
      return {
        type: e.ITEM_TYPES.PAGE,
        key: i,
        value: i,
        isActive: i === a
      };
    };
  }, M;
}
var ce;
function mi() {
  if (ce) return U;
  ce = 1;
  var e = fi(), t = gi();
  function a(r) {
    if (r == null)
      throw new Error("getPaginationModel(): options object should be a passed");
    var d = Number(r.totalPages);
    if (isNaN(d))
      throw new Error("getPaginationModel(): totalPages should be a number");
    if (d < 0)
      throw new Error("getPaginationModel(): totalPages shouldn't be a negative number");
    var v = Number(r.currentPage);
    if (isNaN(v))
      throw new Error("getPaginationModel(): currentPage should be a number");
    if (v < 0)
      throw new Error("getPaginationModel(): currentPage shouldn't be a negative number");
    if (v > d)
      throw new Error("getPaginationModel(): currentPage shouldn't be greater than totalPages");
    var g = r.boundaryPagesRange == null ? 1 : Number(r.boundaryPagesRange);
    if (isNaN(g))
      throw new Error("getPaginationModel(): boundaryPagesRange should be a number");
    if (g < 0)
      throw new Error("getPaginationModel(): boundaryPagesRange shouldn't be a negative number");
    var f = r.siblingPagesRange == null ? 1 : Number(r.siblingPagesRange);
    if (isNaN(f))
      throw new Error("getPaginationModel(): siblingPagesRange should be a number");
    if (f < 0)
      throw new Error("getPaginationModel(): siblingPagesRange shouldn't be a negative number");
    var o = !!r.hidePreviousAndNextPageLinks, x = !!r.hideFirstAndLastPageLinks, h = !!r.hideEllipsis, q = h ? 0 : 1, k = [], S = t.createPageFunctionFactory(r);
    if (x || k.push(t.createFirstPageLink(r)), o || k.push(t.createPreviousPageLink(r)), 1 + 2 * q + 2 * f + 2 * g >= d) {
      var G = e.createRange(1, d).map(S);
      k.push.apply(k, G);
    } else {
      var Y = 1, H = g, N = e.createRange(Y, H).map(S), b = d + 1 - g, P = d, T = e.createRange(b, P).map(S), E = Math.min(Math.max(v - f, H + q + 1), b - q - 2 * f - 1), X = E + 2 * f, be = e.createRange(E, X).map(S);
      if (k.push.apply(k, N), !h) {
        var ee = E - 1, ye = ee === H + 1, ve = ye ? S : t.createFirstEllipsis, ke = ve(ee);
        k.push(ke);
      }
      if (k.push.apply(k, be), !h) {
        var te = X + 1, _e = te === b - 1, Se = _e ? S : t.createSecondEllipsis, pe = Se(te);
        k.push(pe);
      }
      k.push.apply(k, T);
    }
    return o || k.push(t.createNextPageLink(r)), x || k.push(t.createLastPageLink(r)), k;
  }
  U.getPaginationModel = a;
  var i = he();
  return U.ITEM_TYPES = i.ITEM_TYPES, U.ITEM_KEYS = i.ITEM_KEYS, U;
}
var hi = mi();
const bi = { class: "pagination-container" }, yi = {
  class: "pagination",
  role: "navigation"
}, zi = {
  __name: "ds-organism-pagination",
  props: {
    linkComponent: {
      type: String,
      required: !1,
      default: "a"
    },
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !1,
      default: 1
    },
    linkStructure: {
      type: String,
      required: !1,
      default: "?page={{i}}"
    },
    ariaNextPage: {
      type: String,
      required: !1,
      default: "Next page"
    },
    ariaPreviousPage: {
      type: String,
      required: !1,
      default: "Previous page"
    },
    ariaPage: {
      type: String,
      required: !1,
      default: "Page {{i}}"
    }
  },
  setup(e) {
    const t = e, a = Ie(), { device: i } = ra(a), r = z(() => hi.getPaginationModel({
      currentPage: t.currentPage,
      totalPages: t.totalPages,
      hideFirstAndLastPageLinks: !0,
      boundaryPagesRange: i.value === "mobile" ? 0 : 1,
      hideEllipsis: i.value === "mobile"
    }).filter((f) => (f.type !== "PREVIOUS_PAGE_LINK" || t.currentPage !== 1) && (f.type !== "NEXT_PAGE_LINK" || t.currentPage !== t.totalPages))), d = (g) => t.linkStructure.replace("{{i}}", g), v = (g) => g.type === "PREVIOUS_PAGE_LINK" ? t.ariaPreviousPage : g.type === "NEXT_PAGE_LINK" ? t.ariaNextPage : g.type === "PAGE" ? t.ariaPage.replace("{{i}}", g.value) : null;
    return (g, f) => (l(), n("div", bi, [
      s("nav", yi, [
        (l(!0), n(B, null, D(r.value, (o) => (l(), w(V(e.linkComponent), {
          key: o.key,
          class: y([
            "pagination__button",
            {
              "pagination__button--active": o.isActive,
              "pagination__button--ellipsis": o.type === "ELLIPSIS",
              "pagination__button--navigation": o.type === "PREVIOUS_PAGE_LINK" || o.type === "NEXT_PAGE_LINK",
              "pagination__button--link": o.type === "PAGE" && !o.isActive
            }
          ]),
          href: o.type !== "ELLIPSIS" && !o.isActive ? d(o.value) : void 0,
          "aria-label": v(o)
        }, {
          default: p(() => [
            o.type === "PREVIOUS_PAGE_LINK" ? (l(), w(_(Q), {
              key: 0,
              icon: _(ge),
              class: "pagination__navigation-icon"
            }, null, 8, ["icon"])) : o.type === "NEXT_PAGE_LINK" ? (l(), w(_(Q), {
              key: 1,
              icon: _(me),
              class: "pagination__navigation-icon"
            }, null, 8, ["icon"])) : o.type === "ELLIPSIS" ? (l(), n(B, { key: 2 }, [
              j(" ... ")
            ], 64)) : (l(), n(B, { key: 3 }, [
              j(m(o.value), 1)
            ], 64))
          ]),
          _: 2
        }, 1032, ["class", "href", "aria-label"]))), 128))
      ])
    ]));
  }
};
export {
  Ci as DsAtomBarProcess,
  F as DsAtomButton,
  qi as DsAtomHeading,
  A as DsAtomIcon,
  Pi as DsAtomInput,
  wi as DsAtomSelect,
  Ii as DsAtomTextarea,
  xi as DsMoleculeItemIcon,
  vl as DsMoleculeMagazineArticleCard,
  Li as DsMoleculeTrust,
  Ti as DsOrganismCardIcon,
  $i as DsOrganismCardImageSmall,
  Ei as DsOrganismContentColumnCheckmarks,
  Ai as DsOrganismCtaWithImage,
  Mi as DsOrganismIconLinkBar,
  Bi as DsOrganismListMagazineArticles,
  Hi as DsOrganismLogoWithButton,
  zi as DsOrganismPagination
};
//# sourceMappingURL=marketplaces.es.js.map
